import api from './api';

const consultaService = {
  consultarDNI: async (dni) => {
    try {
      const response = await api.get(`/consultas/dni/${dni}`);
      return response.data;
    } catch (error) {
      // Capturar el error específico para manejarlo mejor en la UI
      if (error.response) {
        // La respuesta del servidor contiene un mensaje de error (404, 500, etc.)
        const errorData = {
          ...error,
          message: error.response.data?.message || 'Error al consultar DNI',
          status: error.response.status
        };
        throw errorData;
      } else if (error.request) {
        // No se recibió respuesta del servidor
        throw new Error('No se obtuvo respuesta del servidor. Verifique su conexión.');
      } else {
        // Error al configurar la solicitud
        throw new Error(`Error al consultar DNI: ${error.message}`);
      }
    }
  }
};

export default consultaService;